import * as feather from 'feather-icons';

export function registerIcon(descriptor) {
  const { name, contents, attrs = {}, tags = [] } = descriptor;

  feather.icons[name] = {
    name,
    contents,
    attrs: {
      xmlns: 'http://www.w3.org/2000/svg',
      width: 24,
      height: 24,
      viewBox: '0 0 24 24',
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 2,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      class: `feather feather-${name}`,
      ...attrs,
    },
    tags,
  };
}

export function registerIcons(descriptors) {
  descriptors.forEach(registerIcon);
}
